import React, { useEffect, useState } from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { db } from "../../firebase/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

const currentYear = new Date().getFullYear();
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8", "#82ca9d"];

const DashboardPage = () => {
  const [socios, setSocios] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const sociosSnap = await getDocs(collection(db, "miembros"));
      const pagosSnap = await getDocs(collection(db, "anualidades"));
      setSocios(sociosSnap.docs.map(doc => doc.data()));
      setPagos(pagosSnap.docs.map(doc => doc.data()));
      setLoading(false);
    };
    fetchData();
  }, []);

  const sociosPorPais = () => {
    const count = {};
    socios.forEach(s => {
      const pais = s.PAIS || "Sin País";
      count[pais] = (count[pais] || 0) + 1;
    });
    return Object.entries(count)
      .map(([pais, cantidad]) => ({ pais, cantidad }))
      .sort((a, b) => b.cantidad - a.cantidad);
  };

  const sociosActivosInactivos = () => {
    const activos = new Set(pagos.filter(p => parseInt(p.ANIO) === currentYear).map(p => p.ID));
    const total = new Set(socios.map(s => s.ID));
    return [
      { name: "Activos", value: activos.size },
      { name: "Inactivos", value: total.size - activos.size },
    ];
  };

  const sociosSinPagos = () => {
    const conPagos = new Set(pagos.map(p => p.ID));
    const sinPagos = socios.filter(s => !conPagos.has(s.ID));
    return sinPagos.length;
  };

  const sociosPorAnio = () => {
    const count = {};
    socios.forEach(s => {
      if (!s.FECHA_MEMBRESIA) return;
      const anio = new Date(s.FECHA_MEMBRESIA).getFullYear();
      count[anio] = (count[anio] || 0) + 1;
    });
    return Object.entries(count)
      .map(([anio, cantidad]) => ({ anio, cantidad }))
      .sort((a, b) => a.anio - b.anio);
  };

  return (
    <Container maxWidth={false} sx={{ px: { xs: 2, md: 6 } }}>
      <Typography variant="h4" mt={8} mb={4}>Dashboard de Socios</Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 4 }}>
        <Box sx={{ flex: '1 1 48%', minWidth: 300 }}>
          <Typography variant="h6" mb={2}>Cantidad de Socios por País</Typography>
          {loading ? (
            <Typography>Cargando...</Typography>
          ) : (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={sociosPorPais()}>
                <XAxis dataKey="pais" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="cantidad" fill="#1976d2" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </Box>
        <Box sx={{ flex: '1 1 48%', minWidth: 300 }}>
          <Typography variant="h6" mb={2}>Socios Activos vs Inactivos ({currentYear})</Typography>
          {loading ? (
            <Typography>Cargando...</Typography>
          ) : (
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={sociosActivosInactivos()}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {sociosActivosInactivos().map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          )}
        </Box>
        <Box sx={{ flex: '1 1 48%', minWidth: 300 }}>
          <Typography variant="h6" mb={2}>
            Socios sin ningún pago registrado: {sociosSinPagos()}
          </Typography>
        </Box>
        <Box sx={{ flex: '1 1 48%', minWidth: 300 }}>
          <Typography variant="h6" mb={2}>Cantidad de Socios Registrados por Año</Typography>
          {loading ? (
            <Typography>Cargando...</Typography>
          ) : (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={sociosPorAnio()}>
                <XAxis dataKey="anio" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="cantidad" fill="#2e7d32" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default DashboardPage;